export default __webpack_public_path__ + "static/media/Gloves of Bedlam.60ba1a6c.jpg";